import { Directive, ElementRef, HostListener, Input, Renderer2, OnInit, inject } from '@angular/core';

const baseStyles = {
  cursor: 'pointer',
} as const;

const truncateStyles = (lines: number) =>
  ({
    '-webkit-line-clamp': lines,
    display: '-webkit-box',
    '-webkit-box-orient': 'vertical',
    overflow: 'hidden',
    'text-overflow': 'ellipsis',
  }) as const;

@Directive({
  selector: '[outlawTextTruncate]',
  exportAs: 'outlawTextTruncate',
})
export class TextTruncateDirective implements OnInit {
  @Input() outlawTextTruncate: string | number = 2;

  private isExpanded = false;

  #el = inject(ElementRef);
  #renderer = inject(Renderer2);

  ngOnInit(): void {
    this.applyStyles();
  }

  @HostListener('click')
  onClick(): void {
    this.isExpanded = !this.isExpanded;
    this.applyStyles();
  }

  reset(): void {
    this.isExpanded = false;
    this.applyStyles();
  }

  private applyStyles(): void {
    const allStyles = {
      ...baseStyles,
      ...truncateStyles(Number(this.outlawTextTruncate)),
    };

    const styles = this.isExpanded ? baseStyles : allStyles;

    Object.keys(allStyles).forEach(style => {
      this.#renderer.removeStyle(this.#el.nativeElement, style);
    });

    Object.entries(styles).forEach(([style, value]) => {
      this.#renderer.setStyle(this.#el.nativeElement, style, value);
    });
  }
}
